import React from 'react';
import { Container } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import valdatedMark from '../../../static/images/validatedMark.png';
import homehub_app from '../../../static/images/homehub-logo.png';
import homehub_image from '../../../static/images/homehub_image.png';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { DesktopFullBackground } from '../../components/atoms/DesktopFullBackground';
import { ApplicantType, isContractorOnly } from '../../modules/invitation';
import google_play_badge from '../../../static/images/google_play_badge.png';
import apple_store_badge from '../../../static/images/apple_store_badge.svg';
import {
  guideAppType,
  SumamoruInstallAppType
} from '../../modules/property/types';
import BitlockApplyCompleteScreen from './BitlockApplyCompleteScreen';

const useStyles = makeStyles(() =>
  createStyles({
    image: {
      marginTop: 40,
      width: 90
    },
    titleBar: {
      background: 'var(--color-key)',
      textAlign: 'center',
      paddingBottom: 20,
      '@media (min-width:768px)': {
        borderRadius: '10px 10px 0 0'
      }
    },
    completeCard: {
      textAlign: 'center',
      padding: '0 24px 80px'
    },
    completeHeading: {
      color: 'var(--color-text)',
      fontSize: 20,
      fontWeight: 300,
      fontStyle: 'normal',
      letterSpacing: '0.5px',
      margin: '24px 0 0'
    },
    completeDescription: {
      color: 'var(--color-text)',
      fontSize: 12,
      lineHeight: '18px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      margin: '16px 0 0'
    },
    completeBackground: {
      background: '#03A9F4',
      minHeight: '100vh',
      textAlign: 'center'
    },
    completeHeader: {
      textAlign: 'center',
      padding: '0 16px'
    },
    completeHeaderTitle: {
      color: '#fff',
      fontSize: '16px',
      paddingTop: 20,
      margin: 0,
      letterSpacing: '0.08em'
    },
    completeHeaderMain: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 24
    },
    completeHeaderIcon: {
      color: 'var(--color-white)',
      fontSize: 32,
      marginRight: 12
    },
    completeHeaderText: {
      color: 'var(--color-white)',
      fontSize: 20,
      fontWeight: 300,
      fontStyle: 'normal',
      letterSpacing: '0.5px',
      margin: 0
    },
    completeBody: {
      margin: 0,
      padding: '0 24px 40px',
      '@media (min-width:768px)': {
        backgroundColor: '#F7FCFF',
        padding: 0,
        maxWidth: '100%',
        paddingBottom: '100px'
      }
    },
    hr: {
      opacity: 0.3,
      margin: '48px 0 0',
      width: 'calc(100% - 2px)'
    },
    serviceDescHeading: {
      color: 'var(--color-white)',
      fontSize: 16,
      letterSpacing: '0.5px',
      fontWeight: 600,
      marginTop: 32,
      '@media (min-width:768px)': {
        fontWeight: 300,
        fontSize: 20,
        color: 'var(--color-text)'
      }
    },
    card: {
      marginTop: 16,
      background: 'var(--color-white)',
      borderRadius: 10,
      width: '100%',
      padding: '20px 0 16px',
      textAlign: 'left',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.16)',
      '@media (min-width:768px)': {
        width: 640,
        margin: '16px auto 0'
      }
    },
    cardTitle: {
      color: 'var(--color-text)',
      fontSize: 16,
      fontWeight: 500,
      margin: 0,
      padding: '0 16px'
    },
    cardImage: {
      display: 'block',
      width: '100%',
      maxWidth: 320,
      margin: '16px auto 0'
    },
    cardText: {
      color: 'var(--color-text)',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 300,
      textAlign: 'left',
      lineHeight: '140%',
      padding: '0 16px',
      margin: '16px 0 0'
    },
    appLinkAreaWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      marginTop: 16
    },
    homehubLogo: {
      width: 140
    },
    appLinkWrapper: {
      marginTop: 8,
      display: 'flex',
      alignItems: 'center'
    },
    appleAppLink: {
      marginRight: 8
    },
    appleAppImg: {
      width: 125
    },
    googleAppLink: {
      marginLeft: 8
    },
    googleAppImg: {
      width: 154
    }
  })
);

type PropsFromParent = {
  isAlready?: boolean;
  hasElectricContract?: boolean;
  sumamoruInstallAppTypes?: Array<string>;
  applicantType: ApplicantType;
};

const ApplyCompleteScreen: React.FC<PropsFromParent> = props => {
  const styles = useStyles();
  const history = useHistory();
  const applicationType = props.applicantType;
  const isContractorUser = isContractorOnly(applicationType);

  const checkAlreadyRegistered = history.location.state
    ? history.location.state.isAlreadyRegistered
    : false;
  const title =
    props.hasElectricContract === true
      ? 'スマモル賃貸プラン申し込み'
      : 'スマモル賃貸サービス申し込み';

  const isGuideBitlock: boolean =
    guideAppType(props.sumamoruInstallAppTypes) ===
    SumamoruInstallAppType.bitlock;

  if (isGuideBitlock) {
    return (
      <BitlockApplyCompleteScreen
        isAlready={props.isAlready}
        hasElectricContract={props.hasElectricContract}
      />
    );
  }

  return isContractorUser ? (
    <DesktopFullBackground>
      <div className={styles.titleBar}>
        <h1 className={styles.completeHeaderTitle}>{title}</h1>
      </div>
      <Container className={styles.completeCard}>
        <img className={styles.image} src={valdatedMark} alt={'申し込み完了'} />
        <h1 className={styles.completeHeading}>お申し込みが完了しました</h1>
        <p className={styles.completeDescription}>
          「お申し込み完了のお知らせ」メールを送信しましたので、
          <br />
          ご確認ください。
        </p>
      </Container>
    </DesktopFullBackground>
  ) : (
    <div className={styles.completeBackground}>
      <div className={styles.completeHeader}>
        <h1 className={styles.completeHeaderTitle}>{title}</h1>
        <div className={styles.completeHeaderMain}>
          <CheckCircleOutlineIcon className={styles.completeHeaderIcon} />
          <p className={styles.completeHeaderText}>
            {props.isAlready || checkAlreadyRegistered
              ? 'すでにお申し込みが完了しています'
              : 'お申し込みが完了しました'}
          </p>
        </div>
      </div>
      <Container className={styles.completeBody}>
        <hr className={styles.hr} />
        <h2 className={styles.serviceDescHeading}>各サービスのご利用方法</h2>
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>homehubアプリについて</h3>
          <img
            className={styles.cardImage}
            src={homehub_image}
            alt={'homehubアプリ'}
          />
          <p className={styles.cardText}>
            入居予定のお部屋には、スマートロックが設置されています。
            <br />
            「homehub」アプリを使用して、お部屋のカギを解施錠できます。
          </p>
          <p className={styles.cardText}>
            アプリは下のボタンからダウンロードしてください。
            <br />
            必ず、当サイトで認証したBitkeyアカウントでログインし、ご利用ください。
          </p>
          <div className={styles.appLinkAreaWrapper}>
            <img
              alt={'homehub'}
              src={homehub_app}
              className={styles.homehubLogo}
            />
            <div className={styles.appLinkWrapper}>
              <a
                href={'https://apps.apple.com/jp/app/homehub/id1545859399'}
                className={styles.appleAppLink}
              >
                <img
                  alt="App Store からダウンロード"
                  src={apple_store_badge}
                  className={styles.appleAppImg}
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=app.jp.co.bitkey.homehub&hl=ja&gl=US"
                className={styles.googleAppLink}
              >
                <img
                  alt="Google Play で手に入れよう"
                  src={google_play_badge}
                  className={styles.googleAppImg}
                />
              </a>
            </div>
          </div>
        </div>
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>付帯サービスについて</h3>
          <p className={styles.cardText}>
            homehubアプリ内からアクセスできます。
            <br />
            一部ログインが必要なサービスについては、
            <br />
            サービスサイト・ID・パスワードを別途メールでお知らせします。
          </p>
          <p className={styles.cardText}>
            申し込みが完了しているのにサービスをご利用いただけない場合は、
            <br />
            お手数ですが「入居手続き完了」メールに記載されているサポートまでご連絡ください。
          </p>
        </div>
      </Container>
    </div>
  );
};

export default ApplyCompleteScreen;
